{
  "back": "رجوع",
  "form": "النموذج",
  "purposeTitle": "ما هو هدف توقفك؟",
  "appointmentInfoTitle": "معلومات الموعد",
  "appointmentInfoHint": "تأكد من ملء هذا الحقل إذا كان لديك موعد.",
  "checkInDetailsTitle": "تفاصيل تسجيل الوصول",
  "checkInDetailsHint": "معلومات إضافية حول زيارتك.",
  "driverPhoneLabel": "رقم هاتف السائق",
  "activateWhatsAppTitle": "تفعيل رسائل واتساب",
  "activateWhatsAppBody": "للتواصل مع المستودع، يرجى الرد بـ \"OK\" عند إرسالنا لك أول رسالة واتساب.",
  "whatsappDelayBanner": "قد تستغرق رسالة واتساب الأولى ما يصل إلى دقيقة واحدة للوصول.",
  "notesLabel": "ملاحظات",
  "notesPlaceholder": "هل لديك تعليمات خاصة أو ملاحظات للمنشأة؟",
  "addNoteToWarehouse": "إضافة ملاحظة للمستودع",
  "verifyAndCheckIn": "تحقق وسجّل الوصول",
  "completeCheckIn": "إتمام تسجيل الوصول",
  "visitGroupInbound": "وارد",
  "visitGroupOutbound": "صادر",
  "visitGroupBoth": "وارد وصادر",
  "visitUnloadTruck": "تفريغ شاحنتي",
  "visitDropTrailer": "إيداع مقطورتي أو الحاوية",
  "visitLoadTruck": "تحميل شاحنتي",
  "visitHookTrailer": "ربط مقطورة أو حاوية",
  "visitUnloadLoad": "تفريغ وتحميل شاحنتي",
  "visitDropHook": "إيداع وربط مقطورة أو حاوية",
  "containerTrailer": "مقطورة",
  "containerContainer": "حاوية",
  "containerOversized": "بضاعة ضخمة الحجم",
  "containerOther": "أخرى",
  "defaultReferenceName": "رقم أمر الشراء",
  "identifierSuffix": "{reference} أو رقم التأكيد",
  "licenseOrDotRequired": "يرجى ملء رقم لوحة الترخيص أو رقم DOT",
  "appointmentNotFound": "لم نتمكن من تحديد موعدك",
  "referenceNotFound": "لم يتم العثور على موعد مطابق. أرقام المرجع حساسة لحالة الأحرف.",
  "referenceCaseSensitiveHint": "رقم المرجع حساس لحالة الأحرف",
  "messaging": {
    "whatsappFailedTitle": "تعذر إرسال رسالة واتساب",
    "smsFailedTitle": "تعذر إرسال رسالة SMS",
    "whatsappFailedBody": "لم نتمكن من إرسال رسالة إلى {displayPhone}. <br /><br /> إذا كنت قد ألغيت الاشتراك سابقًا، يرجى إرسال START إلى <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> لبدء تلقي الرسائل من هذا المستودع.",
    "smsFailedBody": "لم نتمكن من إرسال رسالة إلى {displayPhone}. <br /><br /> إذا كنت قد ألغيت الاشتراك سابقًا، يرجى إرسال START إلى <a href='{smsUrl}'>{senderPhone}</a> لبدء تلقي رسائل SMS من هذا المستودع.",
    "fallbackPhone": "رقم الهاتف المقدم"
  }
}
